module.exports = __webpack_public_path__ + "img/down2.a13c0941.svg";